import React from 'react'
import '@loyal_template/notfound.css'
const EmptyOffers = () => {
  return (
    <div className='container not-found py-3'>
      <div
        className={`box-notfound row my-4 mt-md-0 py-3 px-3 mx-1 bg-white radius border border-color-ui-3`}
      >
        <div className='col-12 col-sm-auto'>
          <div className='row'>
            <div className='col-auto mx-auto'>
              <div className='bg-ui-4 radius-circle px-3 py-3'>
                <i className='icon icon_loupe txt-headline color-brand-1' />
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 col-sm mt-2'>
          <h3 className='txt-left mb-1'>
            Nenhuma oferta cadastrada
          </h3>
        </div>
      </div>
    </div>
  )
}

export default EmptyOffers



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Store/EmptyOffers.js